import { render, staticRenderFns } from "./SelectRemotePublisher.vue?vue&type=template&id=2a558ad7&lang=pug&"
import script from "./SelectRemotePublisher.vue?vue&type=script&lang=js&"
export * from "./SelectRemotePublisher.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports